import app from '../../config/configApp';
import { UserCard, CreatePost, DatepickerStyle } from '@/core/styled';

[
  {
    name: 'UserCard',
    ...UserCard,
  },
  {
    name: 'CreatePost',
    ...CreatePost,
  },
  {
    name: 'DatepickerStyle',
    ...DatepickerStyle,
  },
  // eslint-disable-next-line array-callback-return
].map((c) => {
  app.component(`sd${c.name}`, c);
});
